export const chart_red = '#CC0000'
export const chart_blue = '#0052B4'
export const chart_black = '#000000'
